module.exports = __webpack_public_path__ + "media/images/area/feature/chubu/related/en/4-36e1a922d944d2f168a04358d44bef50.jpg";